import colorsDictionary from './colorsDictionary'

const setChartColor = ({
  type,
  key
}) => {
  for (let i = 0; i < type.length; i++) {
    const dimension = type[i]
    if(colorsDictionary[dimension]) {
      const value = key.split(',')[0]
      return colorsDictionary[dimension][value]
    }
  }
  return '#000'
}

export default setChartColor
